export default "__VITE_ASSET__C4iAiE8h__"